import { getClient } from '@/lib/restClient';
import { KioskService } from '@/services/Kiosk/KioskService';
import {
  StoreListParams,
  StoreListResponse,
  StoreSettingUpdateParams,
} from '@/services/Kiosk/type';

const getStoreList = async (
  params: StoreListParams
): Promise<StoreListResponse> => {
  const kioskService = new KioskService(getClient());
  const res = await kioskService.storeList(params);
  return res;
};

const updateStoreSetting = async (
  params: StoreSettingUpdateParams
): Promise<unknown> => {
  const kioskService = new KioskService(getClient());
  return await kioskService.updateStoreSetting(params);
};

const uploadStoreMainImage = async (image: File): Promise<string> => {
  const kioskService = new KioskService(getClient());
  const fileExt = image.name.split('.').pop() || image.type.split('/')[1];
  const contentType = image.type;
  const { url } = await kioskService.createStoreMainImagePresignedUrl({
    fileExt,
    contentType,
  });
  const presignedUrl = new URL(url);
  await kioskService.putFile(presignedUrl.toString(), image);
  return presignedUrl.pathname;
};

export {
  getStoreList,
  updateStoreSetting as updateStore,
  uploadStoreMainImage,
};
